const GRID_DEFAULTS = {
  columns: 12,
  rowHeight: 24,
  margin: {
    vertical: 24,
    horizontal: 24
  },
  padding: {
    vertical: 0,
    horizontal: 0
  }
};
export function createFormView(_ref) {
  var _form$steps, _form$steps2, _form$properties;
  let {
    form,
    path = '',
    stepId,
    recursive = true,
    styleParams,
    includeHiddenFields = false,
    isMobile = false
  } = _ref;
  const step = stepId ? (_form$steps = form.steps) == null ? void 0 : _form$steps.find(_ref2 => {
    let {
      id
    } = _ref2;
    return id === stepId;
  }) : (_form$steps2 = form.steps) == null ? void 0 : _form$steps2[0];
  const layout = (step == null ? void 0 : step.layout) ?? {};
  const fields = form.fields ?? [];
  const nameView = ((_form$properties = form.properties) == null ? void 0 : _form$properties.name) ?? '';
  const fieldViews = fields.filter(field => includeHiddenFields || !field.hidden).filter(field => {
    var _layout$large;
    return layout == null || (_layout$large = layout.large) == null || (_layout$large = _layout$large.items) == null ? void 0 : _layout$large.find(item => field.id === item.fieldId);
  }).reduce((result, field) => {
    const fieldView = createFieldView(field, layout, path, recursive, styleParams, isMobile);
    if (fieldView) {
      result.push(fieldView);
    }
    return result;
  }, []).sort(sortFieldViewsByColumn).sort(sortFieldViewsByRow);
  const gridView = createGridView(layout, styleParams, isMobile);
  let formView = {
    name: nameView,
    grid: gridView,
    fields: fieldViews
  };
  if (isMobile) {
    formView = applyMobileLayout(formView);
  }
  return formView;
}
function applyMobileLayout(form) {
  const {
    fields
  } = form.fields.reduce((state, field) => {
    const layout = {
      width: form.grid.columns,
      height: field.layout.height,
      column: 0,
      row: state.row
    };
    state.fields.push({
      ...field,
      layout
    });
    state.row += field.layout.height;
    return state;
  }, {
    row: 0,
    fields: []
  });
  return {
    ...form,
    fields
  };
}
function createFieldView(field, layout, path, recursive, styleParams, isMobile) {
  var _field$view;
  if (!(field.id && (_field$view = field.view) != null && _field$view.fieldType)) {
    return;
  }
  const breakpoint = (layout == null ? void 0 : layout.large) ?? {};
  const items = breakpoint.items ?? [];
  const item = items.find(_ref3 => {
    let {
      fieldId
    } = _ref3;
    return fieldId === field.id;
  });
  if (!item) {
    return;
  }
  const layoutView = createLayoutView(item);
  if (!layoutView) {
    return;
  }
  const fieldTarget = field.target || '';
  const fieldPath = path ? `${path}/${fieldTarget}` : fieldTarget;
  const propertiesView = createPropertiesView(field, fieldPath, recursive, styleParams, isMobile);
  return {
    id: field.id,
    fieldType: field.view.fieldType,
    properties: propertiesView,
    layout: layoutView,
    target: fieldTarget,
    path: fieldPath
  };
}
export function createPropertiesView(field, path, recursive, styleParams, isMobile) {
  const {
    hidden,
    pii,
    nestedFormId
  } = field;
  const {
    label,
    disabled,
    defaultValue,
    fieldType,
    form,
    ...rest
  } = field.view ?? {};
  const {
    required
  } = field.validation ?? {};
  const formView = form && recursive ? createFormView({
    form,
    path,
    recursive: false,
    styleParams,
    isMobile
  }) : undefined;
  return {
    label: label ?? undefined,
    disabled: disabled ?? false,
    hidden: hidden ?? false,
    required: required ?? false,
    pii: pii ?? false,
    defaultValue: defaultValue ?? undefined,
    validation: field.validation ?? {},
    nestedFormId: nestedFormId ?? undefined,
    form: formView,
    ...rest
  };
}
function createLayoutView(layout) {
  const {
    row,
    column,
    width,
    height
  } = layout;
  if (row === null || row === undefined || column === null || column === undefined || width === null || width === undefined || height === null || height === undefined) {
    return;
  }
  return {
    row,
    column,
    width,
    height,
    static: layout.static
  };
}
function createGridView(layout, styleParams, isMobile) {
  const {
    columns,
    rowHeight,
    padding,
    margin
  } = (layout == null ? void 0 : layout.large) ?? {};
  let {
    vertical: marginVertical,
    horizontal: marginHorizontal
  } = margin ?? {};
  const {
    vertical: paddingVertical,
    horizontal: paddingHorizontal
  } = padding ?? {};
  const gridRowHeight = rowHeight ?? GRID_DEFAULTS.rowHeight;
  if (styleParams) {
    var _styleParams$numbers, _styleParams$numbers2;
    marginVertical = styleParams == null || (_styleParams$numbers = styleParams.numbers) == null ? void 0 : _styleParams$numbers.rowSpacing;
    marginHorizontal = styleParams == null || (_styleParams$numbers2 = styleParams.numbers) == null ? void 0 : _styleParams$numbers2.columnSpacing;
  }
  if (isMobile) {
    marginHorizontal = 0;
  }
  return {
    columns: columns ?? GRID_DEFAULTS.columns,
    rowHeight: gridRowHeight,
    margin: {
      vertical: marginVertical ?? GRID_DEFAULTS.margin.vertical,
      horizontal: marginHorizontal ?? GRID_DEFAULTS.margin.horizontal
    },
    padding: {
      vertical: paddingVertical ?? GRID_DEFAULTS.padding.vertical,
      horizontal: paddingHorizontal ?? GRID_DEFAULTS.padding.horizontal
    }
  };
}
function sortFieldViewsByRow(fieldA, fieldB) {
  return fieldA.layout.row - fieldB.layout.row;
}
function sortFieldViewsByColumn(fieldA, fieldB) {
  return fieldA.layout.column - fieldB.layout.column;
}
//# sourceMappingURL=form-view.js.map